import Vue from "vue";
import Vuetify from "vuetify/lib";

// import { Plugin } from "vue-fragment";
import VueMask from "v-mask";
import { VueMaskDirective } from "v-mask";
import { VueMaskFilter } from "v-mask";
import frag from "vue-frag";
import VueYoutube from "vue-youtube";
// import VueFakeInput from 'vue-fake-input';

// Vue.use(VueFakeInput);

Vue.use(Vuetify);
Vue.use(VueYoutube);
// Vue.use(Plugin);
Vue.directive("frag", frag);
Vue.use(VueMask);
Vue.directive("mask", VueMaskDirective);
Vue.filter("VMask", VueMaskFilter);
export default new Vuetify({
  icons: {
    iconfont: "mdiSvg" // default - only for display purposes
  },
  theme: {
    themes: {
      light: {
        background: "#F8FAFC",
        cardOne: "#ffffff",
        primary: "#2563EB",
        secondary: "#64748B",
        accent: "#8B5CF6",
        error: "#EF4444",
        info: "#3B82F6",
        success: "#10B981",
        warning: "#F59E0B",
        primaryApp: "#FFFFFF",
        secondaryApp: "#F1F5F9",
        btnSuccess: "#2563EB",
        btnCancel: "#94A3B8",
        Colorsuccess: "#10B981"
      }
    }
  }
});
